import { localContentPrefix } from '../../../../config';
import { http } from '../../../../api/axios';
import { Pagination } from '../../../../../models/Pagination';
import { ProductFilter, ProductsResponseOut } from '../../../../store/api';

type ParameterTypes = {
    ageCategory: string | null;
    pagination: Pagination;
    filterMap: ProductFilter;
    genre?: string;
    shopLanguage: string | undefined;
};
export const fetchLibxProducts = ({ ageCategory, genre, filterMap, pagination, shopLanguage }: ParameterTypes) => {
    const params = { ...pagination, ageCategory, shopLanguage };
    return http
        .post<ProductsResponseOut>(`${localContentPrefix}/v1/marketplace/genres/:genre/products`, filterMap, {
            pathParams: { genre },
            params
        })
        .then(res => res.data);
};
